import env from "../config/env";

export const siteSeo = {
  siteName: "Kitabon Ki Dolat",
  siteUrl: env.siteUrl || "https://kitabonkidolat.com",
  defaultTitle: "Kitabon Ki Dolat | Books by Dolat Khan Kakar",
  titleTemplate: "%s | Kitabon Ki Dolat",
  defaultDescription:
    "Explore Kitabon Ki Dolat, the official digital library and publishing platform for books, blogs, audiobooks, and literary events by Dolat Khan Kakar.",
  defaultImage: "/logo.png",
  author: "Dolat Khan Kakar",
  twitterHandle: "",
  language: "en",
  locale: "en_PK",
};

export const pageSeo = {
  home: {
    path: "/",
    title: "Kitabon Ki Dolat | Books by Dolat Khan Kakar",
    description:
      "Read English and Urdu books, discover audiobooks, explore author blogs, and follow literary events from Dolat Khan Kakar.",
    keywords: ["Kitabon Ki Dolat", "Dolat Khan Kakar", "Urdu books", "English books", "digital library Pakistan"],
  },
  library: {
    path: "/library",
    title: "My Library",
    description: "Access your saved books, reading progress, and completed titles on Kitabon Ki Dolat.",
    robots: "noindex,nofollow",
  },
  books: {
    path: "/books",
    title: "Books",
    description: "Browse English and Urdu books by Dolat Khan Kakar on Kitabon Ki Dolat.",
    keywords: ["Dolat Khan Kakar books", "Urdu books", "English books", "Kitabon Ki Dolat books"],
  },
  audiobooks: {
    path: "/audiobooks",
    title: "Audio Books",
    description: "Listen to audio books and professional narrations from Kitabon Ki Dolat.",
    keywords: ["Kitabon Ki Dolat audiobooks", "Dolat Khan Kakar audio books", "audio books Pakistan"],
  },
  events: {
    path: "/events",
    title: "Events",
    description: "Explore celebrity book launches and literary events from Kitabon Ki Dolat.",
    keywords: ["Kitabon Ki Dolat events", "book launches Pakistan", "Dolat Khan Kakar events"],
  },
  aboutAuthor: {
    path: "/about-author",
    title: "About Author",
    description: "Learn about Dolat Khan Kakar, the author behind Kitabon Ki Dolat.",
    keywords: ["Dolat Khan Kakar", "About author", "Kitabon Ki Dolat author"],
  },
  reader: {
    title: "Book Reader",
    description: "Private reading view for Kitabon Ki Dolat members.",
    robots: "noindex,nofollow",
  },
  checkout: {
    title: "Checkout",
    description: "Secure checkout for Kitabon Ki Dolat books and subscriptions.",
    robots: "noindex,nofollow",
  },
  paymentStatus: {
    title: "Payment Status",
    description: "Private payment status page for Kitabon Ki Dolat orders.",
    robots: "noindex,nofollow",
  },
  profile: {
    title: "My Profile",
    description: "Private Kitabon Ki Dolat account profile page.",
    robots: "noindex,nofollow",
  },
  blogs: {
    path: "/blogs",
    title: "Blogs",
    description: "Read the latest articles, reflections, book launch stories, and literary notes from Kitabon Ki Dolat.",
    keywords: ["Dolat Khan Kakar blogs", "author journal", "literary blog Pakistan"],
  },
  contact: {
    path: "/contact",
    title: "Contact Kitabon Ki Dolat",
    description: "Contact Kitabon Ki Dolat for reader support, publishing inquiries, orders, and author-related questions.",
  },
  shipping: {
    path: "/shipping",
    title: "Shipping Information",
    description: "Learn about Kitabon Ki Dolat book delivery, shipping timelines, and order handling across Pakistan.",
  },
  privacy: {
    path: "/privacy",
    title: "Privacy Policy",
    description: "Review how Kitabon Ki Dolat collects, uses, and protects reader account and order information.",
  },
  refund: {
    path: "/refund",
    title: "Refund Policy",
    description: "Read the Kitabon Ki Dolat refund policy for digital subscriptions, book purchases, and order issues.",
  },
  terms: {
    path: "/terms",
    title: "Terms of Service",
    description: "Review the terms and conditions for using Kitabon Ki Dolat books, subscriptions, and services.",
  },
  help: {
    path: "/help",
    title: "Help Center",
    description: "Find help for Kitabon Ki Dolat accounts, subscriptions, reading access, and book orders.",
  },
  faqs: {
    path: "/faqs",
    title: "Frequently Asked Questions",
    description: "Answers to common questions about Kitabon Ki Dolat books, subscriptions, payments, and reading access.",
  },
};

export const buildAbsoluteUrl = (path = "/") => {
  if (/^https?:\/\//i.test(path)) return path;
  const cleanPath = path.startsWith("/") ? path : `/${path}`;
  return `${siteSeo.siteUrl}${cleanPath}`;
};

export const stripHtmlForSeo = (html = "") =>
  String(html)
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

export const truncateSeoText = (value = "", maxLength = 155) => {
  const text = String(value).replace(/\s+/g, " ").trim();
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}...`;
};
